module.exports = __webpack_public_path__ + "img/enterprise-main06.954ba8c1.png";